import React from "react";
import PropTypes from "prop-types";

import "../../../styles/fileUploader.scss";

const FileUploader = ({
  id,
  label,
  accept,
  onChange,
  leadingIcon,
  trailingIcon,
}) => {
  const handleFileChanged = (event) => {
    if (!event.target.files) {
      return;
    }

    onChange(event.target.files);
  };

  return (
    <>
      <input
        id={`file-${id}`}
        className="fileuploader-original"
        type="file"
        accept={accept}
        onChange={handleFileChanged}
      />
      <div className="fileuploader">
        <label className="fileuploader-content" htmlFor={`file-${id}`}>
          {leadingIcon && (
            <div
              className="fileuploader-content__icon"
              style={{ marginRight: "8px" }}
            >
              {leadingIcon}
            </div>
          )}
          <span>{label}</span>
          {trailingIcon && (
            <div
              className="fileuploader-content__icon"
              style={{ marginLeft: "8px" }}
            >
              {trailingIcon}
            </div>
          )}
        </label>
      </div>
    </>
  );
};

FileUploader.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  leadingIcon: PropTypes.element,
  trailingIcon: PropTypes.element,
  accept: PropTypes.string,
};

FileUploader.defaultProps = {
  id: "1",
  label: "Select a file",
  onChange: () => {},
  leadingIcon: <></>,
  trailingIcon: <></>,
  accept: "*",
};

export default FileUploader;
